import Profile from './Profile';

export default Profile;


// WEBPACK FOOTER //
// ./src/Components/Main/Profile/index.tsx